// src/frontend/data/books/DarkForest/data/cap20.js

const CAP20 = {
  id: 20,
  title: "Sistema Operativo (Operation System)",
  sections: [
    {
      heading: "El sistema operativo como base de seguridad",
      text: [
        "El sistema operativo es la primera capa de seguridad en tu vida digital. No importa qué tan segura sea tu billetera o qué tan buena sea tu estrategia de backup; si tu sistema operativo está comprometido, todo está en riesgo.",
        "Windows 10 o superior y macOS son opciones razonablemente seguras para la mayoría de usuarios. Sin embargo, si buscas mayor privacidad y control, puedes considerar distribuciones Linux como Ubuntu, o sistemas especializados como Tails o Whonix, diseñados específicamente para la privacidad y el anonimato."
      ]
    },
    {
      heading: "Actualizaciones: la regla de oro",
      text: [
        "El principio más importante de seguridad del sistema operativo es simple: **mantén tu sistema actualizado**.",
        "Muchas vulnerabilidades graves no ocurren por ataques sofisticados, sino por descuido: sistemas sin actualizar, parches pendientes, antivirus desactualizado.",
        "Cada vez que el sistema te notifique sobre una actualización, especialmente relacionada con seguridad (Security Patch), aplícala lo antes posible."
      ]
    },
    {
      heading: "¿Realmente sabes usar tu sistema operativo?",
      text: [
        "Muchos creen que dominar un sistema operativo es 'saber usar el ratón y los programas'. No es así.",
        "Dominar tu sistema implica entender cómo se ejecutan programas, cómo se protegen los archivos, cómo funciona el firewall y cómo se controla el acceso a la información.",
        "Si eres usuario principiante, al menos deberías:",
        "- Usar un buen antivirus (Kaspersky, BitDefender, Malwarebytes).",
        "- Activar el firewall del sistema (Windows Defender Firewall o macOS Firewall).",
        "- Evitar instalar programas desde enlaces dudosos o páginas no oficiales.",
        "- No ejecutar archivos .exe, .dmg, .apk o macros sin verificar su procedencia."
      ]
    },
    {
      heading: "Descargas y ejecución de programas",
      text: [
        "La mayoría de los ataques no se originan en vulnerabilidades complejas, sino en descargas imprudentes.",
        "Nunca descargues software desde enlaces compartidos en Telegram, Discord, Twitter o WhatsApp, aunque provenga de amigos o comunidades.",
        "Descarga SIEMPRE desde sitios oficiales, y cuando sea posible, verifica firmas o hash del archivo."
      ]
    },
    {
      heading: "Protección del dispositivo: ¿qué pasa si te lo roban?",
      text: [
        "Si tu computadora es robada o se pierde, tener una contraseña de inicio (boot password) no es suficiente.",
        "Si el disco no está cifrado, un atacante puede retirar el disco duro e inspeccionar toda tu información, incluidas contraseñas, documentos, wallets y claves privadas.",
        "Por eso, debes activar el cifrado de disco completo:"
      ],
      list: [
        "🪟 Windows: BitLocker — https://docs.microsoft.com/en-us/windows/security/encryption-data-protection",
        "🍎 macOS: FileVault — https://support.apple.com/en-us/HT204837",
        "🐧 Linux: LUKS / dm-crypt"
      ]
    },
    {
      heading: "Herramientas avanzadas de cifrado",
      text: [
        "Si buscas un nivel superior de protección, puedes usar herramientas como VeraCrypt (sucesor de TrueCrypt), que permiten crear volúmenes cifrados ocultos o contenedores indetectables.",
        "Estas herramientas son útiles en casos de confiscación forzada, auditorías o extorsión. Su poder está en la plausible deniability (negación plausible), lo cual permite que nadie pueda probar la existencia real del contenido protegido."
      ],
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/DarckForest/Captura%20de%20pantalla_18-11-2025_11012_ciberseguridad.comillas.edu.jpeg",
        alt: "Interfaz de VeraCrypt",
        caption: "VeraCrypt permite crear volúmenes cifrados avanzados y contenedores invisibles para máxima protección."
      },
      links: [
        "https://veracrypt.fr/"
      ]
    },
    {
      heading: "Protección de BIOS / Firmware",
      text: [
        "Puedes ir un paso más allá activando una contraseña en tu BIOS o firmware. Esto impide que alguien arranque el sistema desde USB, modifique configuraciones críticas o acceda al disco desde otro sistema.",
        "⚠ Pero esto tiene una regla de oro: si activas esta protección, debes guardar tu contraseña de forma segura. Si la olvidas, no hay forma de recuperarla. Nadie, ni tú, ni el fabricante.",
        "El autor tuvo que descartar un equipo completo y perder archivos valiosos por olvidar esta clave. Fue una dura lección, pero una excelente experiencia de seguridad."
      ]
    },
    {
      heading: "Buenas prácticas generales",
      text: [
        "Estas son algunas prácticas esenciales para proteger tu sistema operativo:",
      ],
      bulletPoints: [
        "✔ Mantén siempre el sistema y antivirus actualizados.",
        "✔ No ejecutes archivos descargados sin verificar procedencia.",
        "✔ Evita trabajar con wallets en sistemas compartidos o públicos.",
        "✔ Usa usuarios separados (cuentas) para trabajo, navegación y wallets.",
        "✔ No ejecutes wallets o aplicaciones sensibles con permisos de administrador.",
        "✔ Nunca desactives el firewall para 'hacer más rápido' tu sistema."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Tu sistema operativo es el campo de batalla de toda tu vida digital. Si esta base está comprometida, todo lo demás —wallets, claves privadas, archivos cifrados, contraseñas— puede caer.",
        "Primero protege tu sistema, luego protege tu wallet y después protege tu patrimonio.",
        "La seguridad no comienza en la blockchain. Comienza en tu computadora."
      ]
    }
  ]
};

export default CAP20;
